import React from 'react'
import { Link } from 'react-router-dom'
import Sidebar from './components/Sidebar'
import {
  PenSquare,
  Newspaper,
  Package,
  ShoppingCart,
  ImagePlus,
  LayoutGrid,
  Camera,
  LayoutDashboard,
  Mail,
  Users,
  Info,
  Tag,
} from 'lucide-react'

const cards = [
  { to: '/admin/create', label: 'Create blog post', desc: 'Write and publish a new article', icon: PenSquare },
  { to: '/admin/blog', label: 'Blogs', desc: 'Manage existing blog posts', icon: Newspaper },
  { to: '/admin/upload-product', label: 'Upload product', desc: 'Add a new print to the shop', icon: Package },
  { to: '/admin/orders', label: 'Orders', desc: 'Review customer orders', icon: ShoppingCart },
  { to: '/admin/portfolio-title', label: 'Portfolio title', desc: 'Create portfolio categories', icon: Tag },
  { to: '/admin/upload-to-portfolio', label: 'Portfolio images', desc: 'Upload images to portfolios', icon: ImagePlus },
  { to: '/admin/exhibition-title', label: 'Exhibition title', desc: 'Create exhibition categories', icon: LayoutGrid },
  { to: '/admin/upload-to-exhibition', label: 'Exhibition images', desc: 'Upload images to exhibitions', icon: ImagePlus },
  { to: '/admin/on-set', label: 'On set', desc: 'Manage on-set gallery', icon: Camera },
  { to: '/admin/homepage-upload', label: 'Overview', desc: 'Manage overview categories & images', icon: LayoutDashboard },
  { to: '/admin/subscribers', label: 'Subscribers', desc: 'View newsletter subscribers', icon: Mail },
  { to: '/admin/users', label: 'Users', desc: 'View registered users', icon: Users },
  { to: '/admin/about', label: 'About', desc: 'Edit about, press & honors', icon: Info },
]

const Home = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 min-w-0 min-h-screen bg-gray-50">
        {/* Top bar */}
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
          <p className="text-sm font-medium text-gray-400">Admin Dashboard</p>
          <span className="text-sm font-semibold text-gray-700">Welcome, Admin</span>
        </div>

        {/* Content */}
        <div className="p-6 md:p-8">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">Welcome back</h1>
            <p className="mt-1 text-sm text-gray-500">Manage your content, shop and people from here.</p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {cards.map(({ to, label, desc, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className="group flex items-start gap-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition duration-150 hover:-translate-y-0.5 hover:border-[#b7a78b] hover:shadow-md"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-neutral-900 text-white transition group-hover:bg-[#b7a78b] group-hover:text-neutral-900">
                  <Icon size={20} />
                </div>
                <div>
                  <p className="font-medium text-gray-800">{label}</p>
                  <p className="mt-0.5 text-sm text-gray-500">{desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
